var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useState } from 'react';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { Input } from '../../form/Input';
import { DotPulseLoader } from '../../loaders';
import { Flex } from '../../../layout';
import { DropdownWrapper, DropdownPrimaryStyled, CaretIcon, Menu, FilterWrapper, ClearFilterButton, Options, Option, ResetOptionsButton, } from './styledComponents';
import { faArrowRotateRight } from '@fortawesome/free-solid-svg-icons';
export var DropdownPrimaryMulti = function (_a) {
    var options = _a.options, _b = _a.defaultText, defaultText = _b === void 0 ? 'Select an option...' : _b, _c = _a.selectedOptionIds, selectedOptionIds = _c === void 0 ? [] : _c, onSelectedOptionsChange = _a.onSelectedOptionsChange, _d = _a.formatLabel, formatLabel = _d === void 0 ? function (options) { return "".concat(options.length, " selected"); } : _d, _e = _a.loading, loading = _e === void 0 ? false : _e, _f = _a.size, size = _f === void 0 ? 'md' : _f, _g = _a.showFilter, showFilter = _g === void 0 ? false : _g, _h = _a.showResetOptions, showResetOptions = _h === void 0 ? false : _h, _j = _a.showCheckboxes, showCheckboxes = _j === void 0 ? true : _j, _k = _a.noOptionsMessage, noOptionsMessage = _k === void 0 ? 'No options available' : _k, _l = _a.label, label = _l === void 0 ? '' : _l, props = __rest(_a, ["options", "defaultText", "selectedOptionIds", "onSelectedOptionsChange", "formatLabel", "loading", "size", "showFilter", "showResetOptions", "showCheckboxes", "noOptionsMessage", "label"]);
    var _m = useState(false), isOpen = _m[0], setIsOpen = _m[1];
    var _o = useState(''), filterTerm = _o[0], setFilterTerm = _o[1];
    var selectedOptions = selectedOptionIds.map(function (optionId) {
        return options.find(function (_a) {
            var id = _a.id;
            return id === optionId;
        });
    });
    //Options filtered by text input
    var filteredOptions = filterTerm
        ? options.filter(function (option) { return option.text.toLowerCase().includes(filterTerm.toLowerCase()); })
        : options;
    var renderOption = function (option) {
        var isOptionSelected = !!selectedOptions.find(function (selectedOption) { return (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.id) === option.id; });
        return (<Option size={size} key={option.id} role="option" selected={isOptionSelected} isShowingButton={showCheckboxes} data-testid={"option-".concat(option.id)} onClick={function () {
                var newSelectedOptions = isOptionSelected
                    ? selectedOptions.filter(function (_a) {
                        var id = _a.id;
                        return id !== option.id;
                    })
                    : __spreadArray(__spreadArray([], selectedOptions, true), [option], false);
                onSelectedOptionsChange(newSelectedOptions);
            }}>
        {showCheckboxes && <input readOnly checked={isOptionSelected} type="checkbox"/>}
        {option.text}
      </Option>);
    };
    var renderOptions = function () {
        if (!filteredOptions.length) {
            return <div style={{ padding: '1.07rem' }}> {noOptionsMessage} </div>;
        }
        return <Options>{filteredOptions.map(renderOption)} </Options>;
    };
    return (<ClickAwayListener onClickAway={function () { return setIsOpen(false); }}>
      <DropdownWrapper {...props}>
        <DropdownPrimaryStyled type="button" data-testid={"".concat(label ? "".concat(label, "-") : '', "multi-dropdown")} onClick={function (e) {
            e.preventDefault();
            setIsOpen(!isOpen);
        }} isOpen={isOpen} size={size}>
          <div>{selectedOptions.length ? formatLabel(selectedOptions) : defaultText} </div>
          <CaretIcon />
        </DropdownPrimaryStyled>
        {isOpen ? (<Menu>
            {showFilter && (<FilterWrapper>
                <Input placeholder="Search" onChange={function (e) { return setFilterTerm(e.target.value); }} value={filterTerm}/>
                <ClearFilterButton onClick={function (e) {
                    e.preventDefault();
                    setFilterTerm('');
                }}>
                  <FontAwesomeIcon icon={faTimes}/>
                </ClearFilterButton>
                {showResetOptions && (<ResetOptionsButton onClick={function (e) {
                        e.preventDefault();
                        setFilterTerm('');
                        onSelectedOptionsChange([]);
                    }}>
                    <FontAwesomeIcon icon={faArrowRotateRight}/>
                  </ResetOptionsButton>)}
              </FilterWrapper>)}
            {loading ? (<Flex spacing="center">
                <DotPulseLoader />
              </Flex>) : (renderOptions())}
          </Menu>) : null}
      </DropdownWrapper>
    </ClickAwayListener>);
};
